// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tag[data-v-cd2e99fc] {\n  margin: 6px;\n}\n[data-v-cd2e99fc] .el-checkbox__label {\n  width: 125px;\n  height: 30px;\n}\n[data-v-cd2e99fc] .el-upload-list__item {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
